/* ==========================================================================
   FLAVONA LANDING PAGE US – Shopify JavaScript
   File: assets/flavona-landing.js

   Buttons use direct cart links with discount codes:
   - 1x Bundle: /cart/53253713920337:1?discount=lnv10-us
   - 2x Bundle: /cart/53253713920337:2?discount=lnv16-us
   - 3x Bundle: /cart/53253713920337:3?discount=lnv34-us
   ========================================================================== */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var page = document.querySelector('.flavona-page');
    if (!page) return;

    // ===== FAQ TOGGLE =====
    page.querySelectorAll('.faq-question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = this.parentElement;
        var isOpen = item.classList.contains('open');
        page.querySelectorAll('.faq-item').forEach(function(i) {
          i.classList.remove('open');
        });
        if (!isOpen) item.classList.add('open');
      });
    });

    // ===== STICKY BOTTOM BAR =====
    var stickyBar = page.querySelector('#stickyBar');
    var hero = page.querySelector('.hero');
    if (stickyBar && hero) {
      var stickyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('visible');
          } else {
            stickyBar.classList.add('visible');
          }
        });
      }, { threshold: 0.1 });
      stickyObserver.observe(hero);
    }

    // ===== COUNTDOWN TIMER (2 days + random hours) =====
    (function() {
      var cdDays = document.getElementById('cd-days');
      var cdHours = document.getElementById('cd-hours');
      var cdMins = document.getElementById('cd-mins');
      var cdSecs = document.getElementById('cd-secs');
      if (!cdDays || !cdHours || !cdMins || !cdSecs) return;

      var stored = sessionStorage.getItem('flavona_cd_end');
      var endTime;
      if (stored) {
        endTime = parseInt(stored);
      } else {
        // 2 days (172800s) + 3-8 random hours
        var secs = 2 * 86400 + (3 * 3600) + Math.floor(Math.random() * 5 * 3600);
        endTime = Date.now() + secs * 1000;
        sessionStorage.setItem('flavona_cd_end', endTime);
      }

      function updateCD() {
        var diff = Math.max(0, endTime - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdDays.textContent = String(d).padStart(2, '0');
        cdHours.textContent = String(h).padStart(2, '0');
        cdMins.textContent = String(m).padStart(2, '0');
        cdSecs.textContent = String(s).padStart(2, '0');
        if (diff > 0) requestAnimationFrame(updateCD);
      }
      updateCD();
      setInterval(updateCD, 1000);
    })();

    // ===== PURCHASE MODE TOGGLE (One-time vs Subscribe) =====
    var toggleBtns = page.querySelectorAll('.toggle-btn');
    var onetimeBundles = document.getElementById('onetime-bundles');
    var subscribeBundles = document.getElementById('subscribe-bundles');
    if (toggleBtns.length && onetimeBundles && subscribeBundles) {
      toggleBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          toggleBtns.forEach(function(b) { b.classList.remove('active'); });
          this.classList.add('active');
          var mode = this.getAttribute('data-mode');
          if (mode === 'subscribe') {
            onetimeBundles.style.display = 'none';
            subscribeBundles.style.display = 'grid';
          } else {
            onetimeBundles.style.display = 'grid';
            subscribeBundles.style.display = 'none';
          }
        });
      });
    }

    // ===== SMOOTH SCROLL (internal #anchor links only) =====
    page.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href && href.length > 1) {
          e.preventDefault();
          var target = page.querySelector(href);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });

    // ===== NAV SHADOW ON SCROLL =====
    var navbar = page.querySelector('#fl-navbar');
    if (navbar) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 10) {
          navbar.style.boxShadow = '0 2px 20px rgba(0,0,0,0.08)';
        } else {
          navbar.style.boxShadow = 'none';
        }
      });
    }

    // ===== CART DRAWER =====
    var cartIcon = page.querySelector('.nav-cart');
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('drawerOverlay');
    var closeBtn = document.getElementById('drawerClose');

    function openDrawer() {
      if (drawer && overlay) {
        drawer.classList.add('open');
        overlay.classList.add('open');
        document.body.classList.add('fl-drawer-open');
      }
    }
    function closeDrawer() {
      if (drawer && overlay) {
        drawer.classList.remove('open');
        overlay.classList.remove('open');
        document.body.classList.remove('fl-drawer-open');
      }
    }

    if (cartIcon) {
      cartIcon.style.cursor = 'pointer';
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    }
    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }
    // ESC key closes the drawer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) {
        closeDrawer();
      }
    });
  });
})();
